import { useEffect, useState } from "react";
import { userService } from "../../services/userService";
import UserDetailCard from "../../components/UserDetailCard";

function UserProfile() {
  const [user, setUser] = useState(null); // store educator details

const fetchUserDetails = async () => {

  try {
    const res = await userService.getUserProfile();
    console.log("Fetched user details:", res);
    setUser(res.data.user);

    
  } catch (error) {
    console.error("Error fetching user details:", error);
  }
};

useEffect(() => {
    fetchUserDetails();
 
}, []);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">User Profile</h1>
        <p className="text-gray-600">Manage your account settings and preferences</p>
      </div>

      <div className="card">
        <div className="card-body">   <div className="col-span-12 md:col-span-4 space-y-4">
                  <div>
                    <UserDetailCard role="Educator" user={user} />
                  </div>
                  <div>
                    {/* <AdminActions userId={id} /> */}
                  </div>
                </div>
          <p className="text-gray-600">User profile management will be implemented here.</p>
        </div>
      </div>
    </div>
  )
}

export default UserProfile